import React, { Component } from "react";
import { withRouter } from "../../../boot/hooks/useRouter";
import { compose } from "recompose";

import { withFirebase } from "../../Firebase";
import Server from "../../../services/Server";

import { getFormattedData } from "../utils";

import View from "./view";

class Resume extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      hasData: false,
      total_viewers: 0,
      average_time: 0,
      viewers_peak: 0,
      cities: false,
      countries: false,
      hours: false,
      limitCities: true,
      limitCountries: true,
      iframeHeight: 350,
      isError: false,
    };

    this.playerContainer = React.createRef();
    this.mounted = true;

    this.onViewMoreCities = this.onViewMoreCities.bind(this);
    this.onViewMoreCountries = this.onViewMoreCountries.bind(this);
    this.onResize = this.onResize.bind(this);

    this.getData = this.getData.bind(this);
  }

  componentDidMount() {
    this.mounted = true;
    if (this.props.eventStatus.code > 0) {
      this.getData();
    }

    window.addEventListener("resize", this.onResize);
  }

  componentWillUnmount() {
    this.mounted = false;
    window.removeEventListener("resize", this.onResize);
  }

  getData() {
    if (this.mounted) {
      const { event } = this.props;

      if (event && event.id) {
        const self = this;

        Server.events
          .getStatistics(this.props.event.id, "resume")
          .then((answer) => {
            const { data, status } = answer;

            if (status === 204) {
              self.setState({ hasData: false, loading: false });
            }

            if (status === 200) {
              const state_data = getFormattedData(data);

              self.setState({ ...state_data, hasData: true, loading: false });
            }
          })
          .catch((err) => {
            console.error(err)
            if (!self.state.isError) {
              self.setState({ isError: true, loading: false });
            }
          });

        if (self.props.eventStatus.code === 2) {
          setTimeout(this.getData, 30000);
        }
      } else {
        setTimeout(this.getData, 5000);
      }
    }
  }

  onResize() {
    if (this.playerContainer.current !== null) {
      const width = this.playerContainer.current.offsetWidth,
        height = 0.5625 * width;

      this.setState({ iframeHeight: height });
    }
  }

  onViewMoreCities() {
    this.setState({ limitCities: !this.state.limitCities });
  }

  onViewMoreCountries() {
    this.setState({ limitCountries: !this.state.limitCountries });
  }

  render() {
    const {
      total_viewers = 0,
      viewers_peak = 0,
      countries = [],
      limitCountries = true,
      isError = false,
    } = this.state;
    const user = {
      id: this.props.currentUser.uid,
      name: this.props.currentUser.displayName,
      photoURL: this.props.currentUser.photoURL,
    };
    const countriesLength = Object.keys(countries).length;
    const { event = {}, eventStatus = {}, firebase } = this.props;

    return (
      <View
        {...this.state}
        total_viewers={total_viewers}
        viewers_peak={viewers_peak}
        countries={countries}
        limitCountries={limitCountries}
        isError={isError}
        event={event}
        eventStatus={eventStatus}
        countriesLength={countriesLength}
        user={user}
        playerContainer={this.playerContainer}
        firebase={firebase}
        onViewMoreCountries={this.onViewMoreCountries}
        onViewMoreCities={this.onViewMoreCities}
        onResize={this.onResize}
      />
    );
  }
}
export default compose(withRouter, withFirebase)(Resume);
